import { createAggregatedClient } from "@smithy/smithy-client";
import { CreateParallelDataCommand, } from "./commands/CreateParallelDataCommand";
import { DeleteParallelDataCommand, } from "./commands/DeleteParallelDataCommand";
import { DeleteTerminologyCommand, } from "./commands/DeleteTerminologyCommand";
import { DescribeTextTranslationJobCommand, } from "./commands/DescribeTextTranslationJobCommand";
import { GetParallelDataCommand, } from "./commands/GetParallelDataCommand";
import { GetTerminologyCommand, } from "./commands/GetTerminologyCommand";
import { ImportTerminologyCommand, } from "./commands/ImportTerminologyCommand";
import { ListLanguagesCommand, } from "./commands/ListLanguagesCommand";
import { ListParallelDataCommand, } from "./commands/ListParallelDataCommand";
import { ListTagsForResourceCommand, } from "./commands/ListTagsForResourceCommand";
import { ListTerminologiesCommand, } from "./commands/ListTerminologiesCommand";
import { ListTextTranslationJobsCommand, } from "./commands/ListTextTranslationJobsCommand";
import { StartTextTranslationJobCommand, } from "./commands/StartTextTranslationJobCommand";
import { StopTextTranslationJobCommand, } from "./commands/StopTextTranslationJobCommand";
import { TagResourceCommand } from "./commands/TagResourceCommand";
import { TranslateDocumentCommand, } from "./commands/TranslateDocumentCommand";
import { TranslateTextCommand, } from "./commands/TranslateTextCommand";
import { UntagResourceCommand, } from "./commands/UntagResourceCommand";
import { UpdateParallelDataCommand, } from "./commands/UpdateParallelDataCommand";
import { TranslateClient } from "./TranslateClient";
const commands = {
    CreateParallelDataCommand,
    DeleteParallelDataCommand,
    DeleteTerminologyCommand,
    DescribeTextTranslationJobCommand,
    GetParallelDataCommand,
    GetTerminologyCommand,
    ImportTerminologyCommand,
    ListLanguagesCommand,
    ListParallelDataCommand,
    ListTagsForResourceCommand,
    ListTerminologiesCommand,
    ListTextTranslationJobsCommand,
    StartTextTranslationJobCommand,
    StopTextTranslationJobCommand,
    TagResourceCommand,
    TranslateDocumentCommand,
    TranslateTextCommand,
    UntagResourceCommand,
    UpdateParallelDataCommand,
};
export class Translate extends TranslateClient {
}
createAggregatedClient(commands, Translate);
